import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { addAdmin, clearAdminData } from "../../actions/admin";
import Button from "../../common/button/button";
import LabelWithHR from "../../common/labels/labelWithHR";
import { newModalStyle, submitButtonStyle } from "../../reusable/styles";

const ModalAddAdminForm = (props) => {
  const { handleSubmit, control } = useForm();
  const [userName, setUserName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [companyName, setCompanyName] = useState("");
  const dispatch = useDispatch();
  const { admin } = useSelector((state) => state.admin);

  const saveAdmin = () => {
    const newData = {
      username: admin ? admin.username : userName,
      firstName: admin ? admin.firstName : firstName,
      lastName: admin ? admin.lastName : lastName,
      phoneNumber,
      companyName,
      email: props.adminsEmail,
    };

    dispatch(addAdmin(newData));
    dispatch(clearAdminData());
    props.close();
  };

  const closeModal = () => {
    props.close();
  };

  const { t } = useTranslation();
  return (
    <Modal
      open={props.open}
      closeOnEsc
      onClose={closeModal}
      center
      styles={newModalStyle({ width: "450px" })}
    >
      <div className="modal__headerLine" />
      <div className="modal__title">Administrator</div>
      <form className="modalForm" onSubmit={handleSubmit(saveAdmin)}>
        <div className="form">
          <LabelWithHR label="E-mail" />
          <Controller
            name="email"
            defaultValue=""
            control={control}
            render={() => (
              <input
                type={"text"}
                className="textStyleInput"
                disabled={props.adminsEmail}
                name="email"
                defaultValue={props.adminsEmail}
              />
            )}
          />

          <LabelWithHR label="Username" />
          <Controller
            name="userName"
            defaultValue=""
            control={control}
            render={() => (
              <input
                type="text"
                className="textStyleInput"
                disabled={props.admin}
                name="userName"
                onChange={(e) => {
                  setUserName(e.target.value);
                }}
                defaultValue={props.admin?.username}
                required
              />
            )}
          />
          <LabelWithHR label={t("Admins.firstName")} />
          <Controller
            name="firstName"
            defaultValue=""
            control={control}
            render={() => (
              <input
                type="text"
                className="textStyleInput"
                disabled={props.admin}
                name="firstName"
                onChange={(e) => {
                  setFirstName(e.target.value);
                }}
                defaultValue={props.admin?.firstName}
                required
              />
            )}
          />
          <LabelWithHR label={t("Admins.lastName")} />
          <Controller
            name="lastName"
            defaultValue=""
            control={control}
            render={() => (
              <input
                type="text"
                label={t("Admins.firstName")}
                className="textStyleInput"
                disabled={props.admin}
                name="lastName"
                onChange={(e) => {
                  setLastName(e.target.value);
                }}
                defaultValue={props.admin?.lastName}
                required
              />
            )}
          />

          <LabelWithHR label={t("Admins.phoneNumber")} />
          <Controller
            name="phoneNumber"
            defaultValue=""
            control={control}
            render={() => (
              <input
                type="text"
                label={t("Admins.firstName")}
                className="textStyleInput"
                name="phoneNumber"
                onChange={(e) => {
                  setPhoneNumber(e.target.value);
                }}
              />
            )}
          />

          <LabelWithHR label={t("Admins.companyName")} />
          <Controller
            name="companyName"
            defaultValue=""
            control={control}
            render={() => (
              <input
                type="text"
                label={t("Admins.firstName")}
                className="textStyleInput"
                name="companyName"
                onChange={(e) => {
                  setCompanyName(e.target.value);
                }}
              />
            )}
          />

          <Button text={t("Buttons.save")} buttonStyle={submitButtonStyle} />
        </div>
      </form>
    </Modal>
  );
};
export default ModalAddAdminForm;
